import api from '@anm/api';
import { DownloadStatus } from '@anm/api/modules/uploads';
import noop from '@anm/helpers/noop';
import { appNotificationActions } from '@anm/store/modules/appNotifications';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

const WATCHER_INTERVAL_TIME = 10_000;

const downloadStreamVideoUrl = async (uploadId: string, onError = noop) => {
  try {
    const url = await api().uploads.getDownloadUrl(uploadId);
    window.open(url, '_blank');
  } catch (error) {
    onError();
  }
};

const useDownloadStreamVideo = (uploadId?: string) => {
  const dispatch = useDispatch();
  const [canWatchDownloadStatus, setWatcher] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const onDownloadNotReady = () => {
    setWatcher(true);
  };

  const handleDownloadStream = () => {
    uploadId && downloadStreamVideoUrl(uploadId, onDownloadNotReady);
  };

  const handelStatusReady = (status: DownloadStatus) => {
    if (status !== 'Ready') return;

    setWatcher(false);
    handleDownloadStream();
    intervalRef?.current && clearInterval(intervalRef?.current);
  };

  useEffect(() => {
    if (!canWatchDownloadStatus || !uploadId) return;

    try {
      api().uploads.generateDownload(uploadId);

      dispatch(
        appNotificationActions.notify({
          type: 'warning',
          title: 'Preparing your video.',
          description: 'It usually takes a few minutes. If the video is long it could take a bit longer.'
        })
      );
    } catch {
      dispatch(
        appNotificationActions.notify({
          type: 'error',
          description: 'Failed to download stream video'
        })
      );
    }

    intervalRef.current = global.setInterval(() => {
      api()
        .uploads.checkLiveDownloadStatus(uploadId)
        .then(handelStatusReady);
    }, WATCHER_INTERVAL_TIME);
  }, [canWatchDownloadStatus]);

  return handleDownloadStream;
};

export default useDownloadStreamVideo;
